// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.k8qMhL898x_6baVuCdJT {
    width: 100%;
    display: flex;
}

.M8llVLwSdoYng3NNqDHK {
    margin: 14px 0;
    box-sizing: border-box;
}

.zWuHk1ecqLvqjMWoJjJx {
    width: 103px;
    height: 30px;
    color: var(--gray-font);
    border: 1px solid var(--light-gray);
}

.zWuHk1ecqLvqjMWoJjJx:disabled {
    color: var(--white);
    background-color: var(--green);
    border: 1px solid var(--green);
}

.F5vdo72xPdog_XS4BXKP {
    border-top-left-radius: 2px;
    border-bottom-left-radius: 2px;
    border-right: none;
}

.FL4pmf4qV7hDwTBAa2ve {
    border-top-right-radius: 2px;
    border-bottom-right-radius: 2px;
    border-left: none;
}

@media (min-width: 768px) {
    .k8qMhL898x_6baVuCdJT {
        justify-content: end;
    }

    .M8llVLwSdoYng3NNqDHK {
        margin: 28px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/LanguageSwitcher.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,mCAAmC;AACvC;;AAEA;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,8BAA8B;AAClC;;AAEA;IACI,2BAA2B;IAC3B,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;IAC5B,+BAA+B;IAC/B,iBAAiB;AACrB;;AAEA;IACI;QACI,oBAAoB;IACxB;;IAEA;QACI,YAAY;IAChB;AACJ","sourcesContent":[".switcherContainer {\n    width: 100%;\n    display: flex;\n}\n\n.languageSwitcher {\n    margin: 14px 0;\n    box-sizing: border-box;\n}\n\n.languageButton {\n    width: 103px;\n    height: 30px;\n    color: var(--gray-font);\n    border: 1px solid var(--light-gray);\n}\n\n.languageButton:disabled {\n    color: var(--white);\n    background-color: var(--green);\n    border: 1px solid var(--green);\n}\n\n.leftButton {\n    border-top-left-radius: 2px;\n    border-bottom-left-radius: 2px;\n    border-right: none;\n}\n\n.rightButton {\n    border-top-right-radius: 2px;\n    border-bottom-right-radius: 2px;\n    border-left: none;\n}\n\n@media (min-width: 768px) {\n    .switcherContainer {\n        justify-content: end;\n    }\n\n    .languageSwitcher {\n        margin: 28px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"switcherContainer": `k8qMhL898x_6baVuCdJT`,
	"languageSwitcher": `M8llVLwSdoYng3NNqDHK`,
	"languageButton": `zWuHk1ecqLvqjMWoJjJx`,
	"leftButton": `F5vdo72xPdog_XS4BXKP`,
	"rightButton": `FL4pmf4qV7hDwTBAa2ve`
};
export default ___CSS_LOADER_EXPORT___;
